import AppHeader from 'components/AppHeader'
import { AuthContextProvider } from 'context/AuthContext'
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom'
import ProtectedRoutes from 'routing/ProtectedRoutes'
import ApplePayCheckout from './checkout/ApplePayCheckout'
import CardCheckout from './checkout/CardCheckout'
import NotFound from './NotFound'
import PaymentDetailPage from './paymentDetails/PaymentDetailsPage'
import PaymentMethodDetailsPage from './PaymentMethodDetailsPage/PaymentMethodDetailsPage'
import PaymentMethodsOverview from './paymentMethods/PaymentMethodsOverview'
import PaymentsOverview from './payments/PaymentsOverview'
import ProcessPayment from './ProcessPayment'
import TerminalDetailPage from './terminalDetails/TerminalDetailsPage'
import TerminalsOverview from './terminals/TerminalsOverview'
import PaymentOperationsOverview from './paymentOperations/PaymentOperationsOverview'
import { PaymentOpsProvider } from './paymentOperations/context/PaymentOperationsContext'
import PaymentFeesOverview from './paymentFees/PaymentFeesOverview'

const Main = () => {
    const router = createBrowserRouter(
        createRoutesFromElements(
            <Route path="/">
                {/* Public routes */}
                <Route path="/card-checkout" element={<CardCheckout />} />
                <Route path="/apple-pay-checkout" element={<ApplePayCheckout />} />
                <Route path="/process-payment" element={<ProcessPayment />} />

                {/* Private routes */}
                <Route
                    path="/"
                    element={
                        <AuthContextProvider>
                            <AppHeader /> {/* We only show the app header on private */}
                            <ProtectedRoutes />
                        </AuthContextProvider>
                    }
                >
                    <Route path="/payments" element={<PaymentsOverview />} />
                    <Route path="/payments/:paymentReference/*" element={<PaymentDetailPage />} />
                    <Route path="/terminals" element={<TerminalsOverview />} />
                    <Route path="/terminals/:externalId" element={<TerminalDetailPage />} />
                    <Route path="/payment-methods" element={<PaymentMethodsOverview />} />
                    <Route
                        path="/payment-methods/:paymentProvider/:paymentMethod/*"
                        element={<PaymentMethodDetailsPage />}
                    />

                    <Route
                        path="/payment-operations/*"
                        element={
                            <PaymentOpsProvider>
                                <PaymentOperationsOverview />
                            </PaymentOpsProvider>
                        }
                    />
                    <Route path="/payment-fees" element={<PaymentFeesOverview />} />
                </Route>

                <Route path="*" element={<NotFound />} />
            </Route>
        )
    )

    return <RouterProvider router={router} />
}

export default Main
